import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { ContactViewContext } from "contexts/ContactView";
import { OutreachContactsContext } from "contexts/OutreachContacts";
import { useContext, useMemo } from "react";
import { ContactProperty, OutreachContact } from "schemas/dashboard";
import { CustomEvent, SetAlertType } from "schemas/functions";

import OutreachStatusChip from "components/OutreachStatusChip";
import { SelectOption } from "features/Influencer/Tracking/schema";
import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../styles";

interface Props {
  contact: OutreachContact;
  stage: SelectOption;
  setAlert: SetAlertType;
  contactProperty: ContactProperty;
}

const SelectStatus = ({ contact, stage, contactProperty, setAlert }: Props) => {
  const { contacts, setContacts, currentContact, setCurrentContact } =
    useContext(OutreachContactsContext);

  const { setOutreachContacts, updateOutreachContactPropertyValues } =
    useContext(ContactViewContext);

  const index = useMemo(() => {
    return contacts.findIndex((c: OutreachContact) => c.id === contact.id);
  }, [contact.id, contacts]);

  const handleSelectOption = (e: CustomEvent) => {
    e.stopPropagation();
    const optionId = e.target.value;

    if (
      contactProperty.id &&
      contact.propertyValues?.[contactProperty.id] === optionId
    ) {
      return;
    }

    if (index >= 0) {
      setContacts((prev) => {
        const copy = makeDeepCopy(prev);
        if (contactProperty.id) {
          copy[index].propertyValues = {
            ...copy[index].propertyValues,
            [contactProperty.id]: optionId,
          };
        }
        return copy;
      });
    }
    if (currentContact?.id === contact.id) {
      setCurrentContact((prev) => {
        const copy = makeDeepCopy(prev);
        if (contactProperty.id) {
          copy.propertyValues = {
            ...copy.propertyValues,
            [contactProperty.id]: optionId,
          };
        }
        return copy;
      });
    }
    setOutreachContacts((prev) => {
      const copy = prev.map((c) => {
        if (c.id !== contact.id) {
          return c;
        }
        const contactCopy = { ...c };
        if (contactProperty.id) {
          contactCopy.propertyValues = {
            ...contactCopy.propertyValues,
            [contactProperty.id]: optionId,
          };
        }
        return contactCopy;
      });
      return copy;
    });

    if (contact.id && contactProperty.id) {
      updateOutreachContactPropertyValues(
        contact.id,
        contactProperty.id,
        optionId,
      );
    }
  };

  return (
    <FormControl sx={{ width: "max-content" }} size="small">
      <Select
        value={stage.id}
        onClick={(event: CustomEvent) => event.stopPropagation()}
        onChange={handleSelectOption}
        label=""
        sx={styles.noBorder}
        renderValue={(selected: string) => (
          <Box key={selected}>
            <OutreachStatusChip stage={stage} />
          </Box>
        )}
      >
        {contactProperty.selectOptions?.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            selected={option.id === stage.id}
          >
            <OutreachStatusChip stage={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default SelectStatus;
